export default __webpack_public_path__ + "static/media/mobile-app-section-bg.6773ce86.png";